module.exports = __webpack_public_path__ + "static/media/a19.f6f30118.jpg";